import { ErrorMessage } from '@hookform/error-message';
import { useFormState } from 'react-hook-form';
import styles from './EpErrorMessage.module.scss';
import { useTranslationStore } from '@/stores';
import { useTranslation as t } from '../../../../hooks/useTranslation';

export const EpErrorMessage = ({ inputName }: { inputName: string }) => {
  const { errors } = useFormState();
  const { translations } = useTranslationStore();

  return (
    <div className={styles['error']}>
      <ErrorMessage
        errors={errors}
        name={`${inputName}`}
        render={({ message }) => {
          if (message === '* Required Fied') {
            return <span>{t(translations['global'], message)}</span>;
          }

          return <span>{message}</span>;
        }}
      />
      <ErrorMessage
        errors={errors}
        name={`${inputName}.inputValue`}
        render={({ message }) => {
          if (message === '* Required Fied') {
            return <span>{t(translations['global'], message)}</span>;
          }
          return <span>{message}</span>;
        }}
      />
    </div>
  );
};
